/**
 * Take an array of times that represent repeated keyframes. For instance
 * if we have original times of [0, 0.5, 1] then our repeated times will
 * be [0, 0.5, 1, 1, 1.5, 2]. Loop over the times and scale them back
 * down to a 0-1 scale.
 */
export function normalizeTimes(times: number[], repeat: number): void {
    for (let i = 0; i < times.length; i++) {
        times[i] = times[i] / (repeat + 1)
    }
}
